import React from 'react'
import ForgotPasswordComponent from '../components/forgotPassword/ForgotPassword.Component';

const ForgotPasswordPageComponent = () => {
  return <ForgotPasswordComponent />
}

export default ForgotPasswordPageComponent;